import { setCustomer } from "@/components/customer/ducks/Actions"
import {
  CLOSE_ENRICHMENT_REQUEST,
  CREATE_SANDBOX,
  DELETE_ALL_CONSTITUENTS,
  GET_IMPORTS_HISTORY,
  GET_INTERNAL_ENRICHMENT_REQUESTS,
  receiveImportsHistory,
  receiveInternalEnrichmentRequests,
  UPDATE_TOTAL_MEMBERS,
  UPLOAD_CONSTITUENT_DATA,
} from "@/components/data/internal/ducks/Actions"
import {
  apiCloseEnrichmentRequest,
  apiCreateSandbox,
  apiDeleteAllConstituents,
  apiGetImportsHistory,
  apiGetInternalEnrichmentRequests,
  apiUpdateTotalMembers,
  apiUploadConstituentData,
} from "@/components/data/internal/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const totalMembersSuccess = (cb) => (resp) => {
    if (resp.customer) {
      dispatch(setCustomer(resp.customer))
    }
    if (cb) {
      cb(resp)
    }
  }

  switch (action.type) {
    case GET_INTERNAL_ENRICHMENT_REQUESTS:
      apiGetInternalEnrichmentRequests(
        receiveInternalEnrichmentRequests,
        action.error,
        action.success,
      )
      return next(action)

    case CLOSE_ENRICHMENT_REQUEST:
      apiCloseEnrichmentRequest(
        action.params,
        receiveInternalEnrichmentRequests,
        action.error,
        action.success,
      )
      return next(action)

    case CREATE_SANDBOX:
      apiCreateSandbox(action.success, action.error)
      return next(action)

    case DELETE_ALL_CONSTITUENTS:
      apiDeleteAllConstituents(action.success, action.error)
      return next(action)

    case UPDATE_TOTAL_MEMBERS:
      apiUpdateTotalMembers(totalMembersSuccess(action.success), action.error)
      return next(action)

    case GET_IMPORTS_HISTORY:
      apiGetImportsHistory(receiveImportsHistory, action.error, action.success)
      return next(action)

    case UPLOAD_CONSTITUENT_DATA:
      apiUploadConstituentData(action.params, receiveImportsHistory, action.error, action.success)
      return next(action)

    default:
      return next(action)
  }
}
